import { render, staticRenderFns } from "./AutoMediaStep.vue?vue&type=template&id=bd79fbca&scoped=true&"
import script from "./AutoMediaStep.vue?vue&type=script&lang=js&"
export * from "./AutoMediaStep.vue?vue&type=script&lang=js&"
import style0 from "./AutoMediaStep.vue?vue&type=style&index=0&id=bd79fbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd79fbca",
  null
  
)

export default component.exports